export const GET_BULK_TAGS = 'getBulkTags';
export const GET_BULK_TAGS_REFERENCES = 'getBulkTagsReferences';
export const DELETE_BULK_TAGS = 'deleteBulkTags';
export const GET_BULK_TAGS_URL = 'getBulkTagsUrl';